import { FormikProps } from 'formik';
import { useCallback, useEffect, useRef } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import { clearFinalValidationSearchParam, isFinalValidationRequested } from '../validation/finalValidationNavigation';
import { forceShowFormValidationErrors } from '../validation/forceShowFormValidationErrors';

export function useApplyFinalValidationOnBind() {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const appliedRef = useRef(false);
  const finalValidationRequested = isFinalValidationRequested(searchParams);

  useEffect(() => {
    appliedRef.current = false;
  }, [location.pathname, finalValidationRequested]);

  const runFinalValidationForFormikRefs = useCallback(
    (formiks: Array<FormikProps<unknown> | null | undefined>) => {
      if (!finalValidationRequested || appliedRef.current) {
        return;
      }
      if (formiks.some((formik) => !formik)) {
        return;
      }

      appliedRef.current = true;
      const boundFormiks = formiks.filter(
        (formik): formik is FormikProps<unknown> => formik !== null && formik !== undefined,
      );

      void Promise.all(boundFormiks.map((formik) => forceShowFormValidationErrors(formik)))
        .catch(() => undefined)
        .finally(() => {
          clearFinalValidationSearchParam(setSearchParams);
        });
    },
    [finalValidationRequested, setSearchParams],
  );

  function onFormikBound(formik: FormikProps<unknown> | null | undefined) {
    runFinalValidationForFormikRefs([formik]);
  }

  function onMultipleFormikBound(formiks: Array<FormikProps<unknown> | null | undefined>) {
    runFinalValidationForFormikRefs(formiks);
  }

  return { onFormikBound, onMultipleFormikBound };
}
